module.exports = __webpack_public_path__ + "img/ic_nat_home_hsyy.95661e95.png";